import React from 'react';
import './VersionPanel.scss';

export interface IVersionPanelProps {
    /** Название приложения (префикс заголовка вкладки) */
    appName: string;
    /** Версия сборки; пока не загружена — пусто */
    version?: string | null;
}

const VersionPanel: React.FC<IVersionPanelProps> = ({ appName, version }) => (
    <div className="version-container">
        <div className="version-container__app-name" data-testid="app-name" title={appName}>
            {appName}
        </div>
        <div className="version-container__app-version" data-testid="app-version">
            {version ?? ''}
        </div>
    </div>
);

export default VersionPanel;
